import { LoginError } from "./LoginError.js";
import { NewPasswordModel } from "../../../models/NewPasswordModel.js";
import "react";
import { FormLayout, Loading, Password } from "@therms/atalaya";
import { jsx, jsxs } from "react/jsx-runtime";
import { useFormModel } from "mvc-kit/react";
//#region src/modules/AuthWrapper2/components/Login/views/NewPassword.tsx
function NewPassword({ error, loading, onCancel, onSubmit }) {
	const { model, state, visibleErrors } = useFormModel(() => new NewPasswordModel({
		newPassword: "",
		newPasswordConfirm: ""
	}));
	const handleSubmit = () => {
		if (loading) return;
		model.submit(({ newPassword }) => onSubmit(newPassword));
	};
	return /* @__PURE__ */ jsxs(FormLayout, {
		dividers: "space",
		space: "sm",
		children: [
			loading && /* @__PURE__ */ jsx(Loading, {
				overlay: true,
				size: "xxl"
			}),
			/* @__PURE__ */ jsx(LoginError, { message: error }),
			/* @__PURE__ */ jsx(Password, {
				error: visibleErrors.newPassword,
				label: "New Password",
				onBlur: () => model.touch("newPassword"),
				onChangeValue: model.setNewPassword,
				value: state.newPassword
			}),
			/* @__PURE__ */ jsx(Password, {
				error: visibleErrors.newPasswordConfirm,
				label: "Confirm Password",
				onBlur: () => model.touch("newPasswordConfirm"),
				onChangeValue: model.setNewPasswordConfirm,
				value: state.newPasswordConfirm
			}),
			/* @__PURE__ */ jsx(FormLayout.Controls, {
				cancelLabel: "Go Back",
				submitLabel: "Change Password",
				onCancel,
				onSubmit: handleSubmit,
				submitting: loading
			})
		]
	});
}
//#endregion
export { NewPassword };

//# sourceMappingURL=NewPassword.js.map